<template>
  <di>
    <el-button type="text" @click="call(column, row)">
      {{ rowValue }}
    </el-button>
  </di>
</template>

<script>
export default {
  name: "LinkdialogOpener",
  props: {
    rowValue: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    },
    call: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style></style>
